import { Routes, Route, Navigate } from 'react-router-dom'
import { HomePage } from '@/pages/HomePage'
import { FlyerPage } from '@/pages/FlyerPage'
import { RegisterPage } from '@/pages/RegisterPage'
import { MerchantRegisterPage } from '@/pages/MerchantRegisterPage'
import { LoginPage } from '@/pages/LoginPage'
import { VerifyEmailPage } from '@/pages/VerifyEmailPage'
import { ApplicantDashboardPage } from '@/pages/applicant/DashboardPage'
import { ScriptViewerPage } from '@/pages/applicant/ScriptViewerPage'
import { ApplicantReviewPage } from '@/pages/admin/ApplicantReviewPage'
import { InterviewManagementPage } from '@/pages/admin/InterviewManagementPage'
import { ScriptManagementPage } from '@/pages/admin/ScriptManagementPage'
import { RegionManagementPage } from '@/pages/admin/RegionManagementPage'
import { BusinessManagementPage } from '@/pages/admin/BusinessManagementPage'
import { SettingsPage } from '@/pages/admin/SettingsPage'
import { VisitControlPage } from '@/pages/admin/VisitControlPage'
import { CompensationManagementPage } from '@/pages/admin/CompensationManagementPage'
import { ScoutDashboardPage } from '@/pages/scout/ScoutDashboardPage'
import { ScoutBusinessListPage } from '@/pages/scout/ScoutBusinessListPage'
import { MyBusinessesPage } from '@/pages/scout/MyBusinessesPage'
import { StartVisitPage } from '@/pages/scout/StartVisitPage'
import { VisitDetailPage } from '@/pages/scout/VisitDetailPage'
import { ReferralPage } from '@/pages/scout/ReferralPage'
import { CompensationPage } from '@/pages/scout/CompensationPage'
import { ProfilePage } from '@/pages/scout/ProfilePage'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { UserRole } from '@shared/types/roles'

export function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/flyer" element={<FlyerPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/merchant/register" element={<MerchantRegisterPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/login" element={<LoginPage />} />

      {/* Applicant Routes */}
      <Route
        path="/applicant/dashboard"
        element={
          <ProtectedRoute allowedRoles={[UserRole.APPLICANT]}>
            <ApplicantDashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/applicant/script"
        element={
          <ProtectedRoute allowedRoles={[UserRole.APPLICANT, UserRole.SCOUT]}>
            <ScriptViewerPage />
          </ProtectedRoute>
        }
      />

      {/* Scout Routes */}
      <Route
        path="/scout/dashboard"
        element={
          <ProtectedRoute allowedRoles={[UserRole.SCOUT]}>
            <ScoutDashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/scout/businesses"
        element={
          <ProtectedRoute allowedRoles={[UserRole.SCOUT]}>
            <ScoutBusinessListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/scout/my-businesses"
        element={
          <ProtectedRoute allowedRoles={[UserRole.SCOUT]}>
            <MyBusinessesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/scout/businesses/:businessId/visit"
        element={
          <ProtectedRoute allowedRoles={[UserRole.SCOUT]}>
            <StartVisitPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/scout/visits/:id"
        element={
          <ProtectedRoute allowedRoles={[UserRole.SCOUT]}>
            <VisitDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/scout/referral"
        element={
          <ProtectedRoute allowedRoles={[UserRole.SCOUT]}>
            <ReferralPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/scout/compensation"
        element={
          <ProtectedRoute allowedRoles={[UserRole.SCOUT]}>
            <CompensationPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/scout/profile"
        element={
          <ProtectedRoute allowedRoles={[UserRole.SCOUT]}>
            <ProfilePage />
          </ProtectedRoute>
        }
      />

      {/* Admin Routes */}
      <Route
        path="/admin/applicants"
        element={
          <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
            <ApplicantReviewPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/interviews"
        element={
          <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
            <InterviewManagementPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/scripts"
        element={
          <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
            <ScriptManagementPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/regions"
        element={
          <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
            <RegionManagementPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/businesses"
        element={
          <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
            <BusinessManagementPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/visits"
        element={
          <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
            <VisitControlPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/compensation"
        element={
          <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
            <CompensationManagementPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/settings"
        element={
          <ProtectedRoute allowedRoles={[UserRole.ADMIN]}>
            <SettingsPage />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
